/* Dietética Ferrer: impresión aislada del resumen nutricional. */
(function () {
  'use strict';
  if (window.DFPrintA4Installed) return;
  window.DFPrintA4Installed = true;

  var PRINT_CSS = `
    @page { size: A4 portrait; margin: 10mm 12mm; }
    *, *::before, *::after { box-sizing: border-box; }
    html, body { margin: 0; padding: 0; background: #fff; color: #244b2d;
      font-family: Arial, Helvetica, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .df-print-sheet { width: 100%; height: 275mm; display: flex; flex-direction: column;
      gap: 8px; margin: 0; padding: 0; overflow: hidden; }
    .df-summary-header { flex: none; border: 1px solid #d8e9d4; background: #f4faf1;
      border-radius: 11px; padding: 13px 17px; margin: 0; }
    .df-report-brand { display: flex; align-items: center; justify-content: space-between;
      gap: 14px; margin: 0 0 7px; }
    .df-report-logo { display: block; width: 130px; max-height: 45px; height: auto;
      object-fit: contain; object-position: left center; }
    .df-report-brand-name { font-size: 20px; font-weight: 700; color: #246735; }
    .df-report-brand-tag { color: #376b43; font-size: 8px; font-weight: 700;
      letter-spacing: .1em; text-align: right; }
    .df-eyebrow { font-size: 8px; font-weight: 700; letter-spacing: .09em; color: #2a7341; }
    h1 { font-family: Georgia, serif; font-size: 23px; color: #184f2c; margin: 4px 0 5px; }
    .df-summary-header p { margin: 0; font-size: 10px; color: #526958; }
    .df-report-header-accent { display: none; }
    .df-summary-content { flex: none; min-height: 0; }
    .df-summary-content > .df-card { border: 1px solid #dce8d8; border-radius: 11px;
      padding: 12px 16px; margin: 0; }
    .df-summary-content h2 { font-family: Georgia, serif; font-size: 19px;
      margin: 4px 0 7px; color: #1c542e; }
    .df-summary-content .df-eyebrow { margin-bottom: 2px; }
    .df-summary-content .df-muted { color: #5e6d61; font-size: 10px; line-height: 1.45; }
    .df-summary-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 7px; margin: 9px 0; }
    .df-summary-stat { display: flex; flex-direction: column; justify-content: center;
      border: 1px solid #d8e8d3; background: #f2f8ef; border-radius: 10px;
      min-height: 72px; padding: 10px 13px; break-inside: avoid; }
    .df-summary-stat--wide { grid-column: 1 / -1; background: #e8f4e3; order: 10; }
    .df-summary-stat span { color: #4d6653; font-size: 10px; }
    .df-summary-stat strong { display: block; color: #1e6939; font-size: 23px;
      line-height: 1.1; margin: 5px 0; }
    .df-summary-stat small { color: #627265; font-size: 9px; }
    .df-summary-content > .df-card > p:last-child { margin-bottom: 0; }
    .df-report-footer { flex: none; position: static; margin-top: auto;
      background: #1e6637; border-radius: 10px; padding: 11px 15px;
      display: flex; justify-content: space-between; align-items: center;
      gap: 12px; color: #fff; }
    .df-report-footer-copy { display: flex; flex-direction: column; gap: 4px; }
    .df-report-footer-copy strong { font-size: 13px; }
    .df-report-footer-copy span, .df-report-footer-link small { font-size: 8px; }
    .df-report-footer-link { text-align: right; font-size: 11px; font-weight: 700; }
    .df-report-footer-link small { font-weight: 400; }
    @media print {
      .df-print-sheet { break-after: auto; page-break-after: auto; }
      .df-summary-header, .df-summary-content > .df-card, .df-summary-stat { break-inside: avoid; }
    }
  `;

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('#df-print-report');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    var page = document.querySelector('[data-df-summary]');
    var header = page && page.querySelector('.df-summary-header');
    var content = page && page.querySelector('#df-summary-content');
    var footer = page && page.querySelector('.df-report-footer');
    if (!header || !content || !footer || !content.querySelector('.df-summary-stat')) {
      alert('Completa las calculadoras antes de guardar el informe.');
      return;
    }

    var frame = document.createElement('iframe');
    frame.title = 'Informe nutricional para imprimir';
    frame.setAttribute('aria-hidden', 'true');
    frame.style.cssText = 'position:fixed;left:-20000px;top:0;width:794px;height:1123px;border:0;visibility:hidden;';
    document.body.appendChild(frame);
    var doc = frame.contentDocument;
    doc.title = 'Mi resumen nutricional - Dietética Ferrer';
    doc.documentElement.lang = 'es';
    var meta = doc.createElement('meta');
    meta.setAttribute('charset', 'utf-8');
    doc.head.appendChild(meta);
    var style = doc.createElement('style');
    style.textContent = PRINT_CSS;
    doc.head.appendChild(style);
    var sheet = doc.createElement('main');
    sheet.className = 'df-print-sheet';
    sheet.appendChild(header.cloneNode(true));
    sheet.appendChild(content.cloneNode(true));
    sheet.appendChild(footer.cloneNode(true));
    doc.body.appendChild(sheet);

    var started = false;
    function printOnce() {
      if (started || !frame.isConnected) return;
      started = true;
      frame.contentWindow.addEventListener('afterprint', function () {
        setTimeout(function () { frame.remove(); }, 1000);
      }, { once: true });
      frame.contentWindow.focus();
      frame.contentWindow.print();
      setTimeout(function () { if (frame.isConnected) frame.remove(); }, 60000);
    }
    var images = Array.from(doc.images);
    Promise.all(images.map(function (img) {
      if (img.complete) return Promise.resolve();
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    })).then(function () { setTimeout(printOnce, 250); });
  }, true);
})();
